export default function(sections, enabledSectionType = 'department') {
    return sections.map(section => {
        const { id, name, depth, type } = section
        return {
            depth,
            value: id,
            label: name,
            icon: type === 'department' ? 'users' : 'industry',
            _type: type,
            $isDisabled: type !== enabledSectionType,
        }
    })
}
